module.exports = __webpack_public_path__ + "img/gray_bullet.62862862.svg";